<template>
  <div class="recent_qns loading_div">
    <div class="top_loading">
      <div class="loading_sm" />
      <div class="loading_sm" />
    </div>
    <div class="bottom_loading">
      <div class="loading_lg" />
      <div class="loading_lg" />
      <div class="loading_lg" />
    </div>
  </div>
</template>
